import React from "react";
import { Button, Form, Spinner } from "react-bootstrap";
import PasswordShowHide from "../PasswordShowHide";
export default function FormLogin({
  connect,
  passwordShow,
  pwd,
  setPwd,
  username,
  setUsername,
  handlePasswordShow,
  loader,
  errorMessage,
  setShowResetPassword,
}) {
  return (
    <Form onSubmit={(e) => connect(e)}>
      <Form.Group className="mb-3" controlId="form-email">
        <Form.Control
          type="text"
          placeholder="Email/Login"
          autoFocus
          //pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
          pattern="[^@\s]+@[^@\s]+\.[^@\s]+"
          autoComplete="on"
          required
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
      </Form.Group>
      <Form.Group className="mb-3" controlId="form-password">
        <Form.Group className="row">
          <div className="col-md-10 pe-0">
            <Form.Control
              type={passwordShow ? "text" : "password"}
              placeholder="Password"
              className="passwordHide"
              required
              autoComplete="on"
              pattern="^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^\w\s]).{8,}$"
              value={pwd}
              onChange={(e) => setPwd(e.target.value)}
            />
          </div>
          <PasswordShowHide
            handlePasswordShow={handlePasswordShow}
            passwordShow={passwordShow}
          />
        </Form.Group>
      </Form.Group>

      <div className="row">
        {loader && (
          <div className="col-md-12 text-center py-2">
            <Spinner
              animation={loader ? "border" : false}
              role="status"
            ></Spinner>
          </div>
        )}
        <div className="col-md-12">
          {errorMessage.length > 0 && !loader && (
            <div className="text-danger pb-3 text-center">{errorMessage}</div>
          )}
        </div>
        <div className="col-md-12 text-end">
          <Button
            variant="primary"
            type="submit"
            className="button green-button hover-blue-background-color"
            disabled={loader ? true : false}
          >
            Se connecter
          </Button>
        </div>
        <div className="col-md-12">
          <Button
            variant=""
            className="p-0 py-1 hover-blue-color small"
            onClick={() => {
              setShowResetPassword(true);
            }}
          >
            Mot de passe oublié ?
          </Button>.
        </div>
      </div>
    </Form>
  );
}
